<div class="w-11/12">
  <h1>Author Search</h1>
  <p>
    <strong>Author Search</strong> allows for efficient searching of authors whose current or past
    affiliation is with Ecuador. You can perform the search using various criteria, such as first
    name, last name, author name, initials, or even the author's Scopus identifier. The results are
    displayed in a paginated table, making it easy to view and explore the results in an organized
    manner.
  </p>
</div>
